import { FONT } from "@/styles/common";
import { Center, Table, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomTitle = styled(Text)`
    ${FONT("cormorant", 52, 500)}

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        ${FONT("cormorant", 32, 500)}
    }
`;

export const CustomTable = styled(Table)`
    width: 100%;
    border-collapse: collapse;
    box-sizing: border-box;
    border: 1px solid ${({ theme }) => theme.COLOR.text[400]};
    table-layout: fixed;

    & tr {
        width: 100%;
        height: 120px;
        box-sizing: border-box;

        @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
            height: 40px;
        }
    }

    & th,
    td {
        white-space: nowrap;
        padding: 0 8px;
        ${FONT("pretendard", 16, 300)}
        text-align: center;
        border: 1px solid ${({ theme }) => theme.COLOR.text[400]} !important;
    }

    & th {
        color: ${({ theme }) => theme.COLOR.text[400]};
        background: ${({ theme }) => theme.COLOR.pagination[100]};

        @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
            white-space: normal;
            ${FONT("pretendard", 14, 300, 1.2)}
        }
    }
`;

export const CustomCenter = styled(Center)`
    width: 100%;
    border-collapse: collapse;

    & .carousel-root {
        width: 100%;
    }

    & .carousel.carousel-slider .control-arrow {
        background: rgba(0, 0, 0, 0.3);
    }
`;

export const CustomRoom = {
    TITLE: styled(Center)`
        width: 20%;
        height: 100%;
        ${FONT("pretendard", 16, 300)}
        background: ${({ theme }) => theme.COLOR.pagination[100]};
        border: 1px solid ${({ theme }) => theme.COLOR.text[400]};

        @media (max-width: ${({ theme }) => theme.MEDIA.tablet}) {
            ${FONT("pretendard", 14, 300)}
        }
    `,
    SEASON: styled(Center)`
        flex-direction: row;
        justify-content: space-evenly;
        border-top: 1px solid ${({ theme }) => theme.COLOR.text[400]};

        & p:first-of-type {
            background: ${({ theme }) => theme.COLOR.text[100]};
        }

        & p {
            width: 100%;
            padding: 48px;
            border-right: 1px solid ${({ theme }) => theme.COLOR.text[400]};
            border-bottom: 1px solid ${({ theme }) => theme.COLOR.text[400]};
            ${FONT("pretendard", 16, 300)}

            @media (max-width: ${({ theme }) => theme.MEDIA.tablet}) {
                ${FONT("pretendard", 14, 300)}
                padding: 24px;
            }

            @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
                padding: 8px 0;
            }
        }
    `,
};

export const CustomText = styled(Text)`
    ${FONT("pretendard", 16, 300)}
    color:${({ theme }) => theme.COLOR.negative}
`;
